"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _reactUtil = require("@lexcelon/react-util");

var _entry = require("react-pdf/dist/esm/entry.webpack");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
* Copyright © 2021 Lexcelon LLC <info@lexcelon.com>
* Licensed for non-distributable use to Ergonauts LLC
*/
function PDFViewer(_ref) {
  let {
    url,
    style
  } = _ref;
  const [numPages, setNumPages] = (0, _react.useState)(null);
  const [pageNumber, setPageNumber] = (0, _react.useState)(1);

  function onDocumentLoadSuccess(_ref2) {
    let {
      numPages
    } = _ref2;
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    style: style
  }, /*#__PURE__*/_react.default.createElement(_material.Paper, {
    elevation: 3
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_entry.Document, {
    file: url,
    onLoadSuccess: onDocumentLoadSuccess
  }, /*#__PURE__*/_react.default.createElement(_entry.Page, {
    pageNumber: pageNumber
  })))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 10
    }
  }, /*#__PURE__*/_react.default.createElement(_reactUtil.Button, {
    disabled: pageNumber <= 1,
    onClick: previousPage,
    style: {
      marginRight: 10
    }
  }, "Previous"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "overline",
    style: {
      width: 250,
      textAlign: 'center'
    }
  }, "Page ", pageNumber, " of ", numPages), /*#__PURE__*/_react.default.createElement(_reactUtil.Button, {
    disabled: pageNumber >= numPages,
    onClick: nextPage,
    style: {
      marginLeft: 10
    }
  }, "Next")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      marginTop: 10,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactUtil.Button, {
    variant: "contained",
    href: url,
    target: "_blank",
    rel: "noreferrer",
    secondary: true
  }, "Download Results")));
}

PDFViewer.propTypes = {
  url: _propTypes.default.string.isRequired,
  style: _propTypes.default.string
};
var _default = PDFViewer;
exports.default = _default;